import React, { useState, useCallback, useContext } from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const HAS_APP_OPTIONS = [
  { label: 'no', value: 0 },
  { label: 'yes', value: 1 }
];

const HasAppFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const hasAppOptions = useTranslatedOptions(HAS_APP_OPTIONS);
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  if (!hasAppOptions.length || (search && !t('hasApp').toLowerCase().includes(search.toLowerCase()))) {
    return null;
  }

  return (
    <FilterLayout name={t('hasApp')} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={hideLayout}>
      {hasAppOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`has-app-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default HasAppFilter;
